module.exports = __webpack_public_path__ + "media/images/icon-profile@3x-784ed318f0dcc592511b3b50207cf04a.png";